import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function Login() {
  const [isPassword, setIsPassword] = useState(true);
  const apiUrl = process.env.REACT_APP_API_URL;

  const [userInfo, setUserInfo] = useState({
    username: "",
    password: "",
  });
  const history = useNavigate();
  const token = localStorage.getItem("spanUserToken");
  const fetchData = async () => {
    if (token && token !== "") {
      try {
        await axios.get(
          `${apiUrl}userdatafetch.php?token=${encodeURIComponent(token)}`
        );
        history("/user");
      } catch (error) {}
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserInfo((prevUserInfo) => ({
      ...prevUserInfo,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const url = `${apiUrl}userlogin.php`;

    try {
      const { username, password } = userInfo;

      const response = await axios.get(
        url,
        {
          params: {
            username: encodeURIComponent(username),
            password: encodeURIComponent(password),
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
          maxContentLength: Infinity,
        }
      );

      const data = response.data;

      localStorage.setItem("spanUserToken", data.token);
      history("/user");
    } catch (error) {
      window.alert("Login failed. Please try again."); // Added user feedback
    }
  };

  return (
    <form autoComplete="off" className="SignIn" onSubmit={handleSubmit}>
      <div>
        <label htmlFor="username">Username</label>
        <input
          type="text"
          id="username"
          name="username"
          value={userInfo.username}
          onChange={handleChange}
        />
        <div className="passwordcontainer">
          <label htmlFor="password">Password</label>
          <input
            type={isPassword ? "password" : "text"}
            id="password"
            name="password"
            value={userInfo.password}
            onChange={handleChange}
          />
          {isPassword ? (
            <i
              className="fa-regular fa-eye"
              onClick={() => setIsPassword(!isPassword)}
            ></i>
          ) : (
            <i
              className="fa-regular fa-eye-slash"
              onClick={() => setIsPassword(!isPassword)}
            ></i>
          )}
        </div>
        <button type="submit">Submit</button>
      </div>
    </form>
  );
}

export default Login;
